import * as c from "../constants/outputs";
import { announce } from './announcements';

export const selectUrl = (url) => (dispatch, getState) => {
  dispatch({
    type: c.OUTPUTS_SELECT_URL,
    url
  });

  // Announce output selection to screen readers
  // Find the title for this URL from the toolbar
  const { toolbar } = getState().outputs;
  let toolTitle = null;

  for (const section of toolbar) {
    const tool = section.tools?.find(t => t.url === url);
    if (tool) {
      toolTitle = tool.title;
      break;
    }
  }

  if (toolTitle) {
    dispatch(announce(`${toolTitle} page loaded`));
  }
};
